// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Autofocus on search field on offcanvas open
document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#predictive-search-input').focus()
})

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors message - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
    errors.classList.add('alert', 'alert-danger')
    errors.querySelector('ul').classList.add('mb-0')
}

// Detect viewport
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // console.log(entry)
                entry.target.classList.add('entered')
                entry.target.querySelectorAll('.animate__animated').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -160px 0px' })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterViewAnimations()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.enter-view')) {
        initEnterViewAnimations()
    }
})

/* Detect scroll */
window.addEventListener('scroll', (e) => {
    const announcementbarHeight = document.querySelector('#shopify-section-announcement-bar').clientHeight || 0
    if (window.scrollY > announcementbarHeight) {
        document.body.classList.add('scrolled')
    } else {
        document.body.classList.remove('scrolled')
    }
})

//
// Transparent header feature on homepage
//
const initTransparentHeader = () => {
    if (document.querySelector('[data-transparent-header="true"]')) {
        document.body.classList.add('transparent-header')
    } else {
        document.body.classList.remove('transparent-header')
    }
}
initTransparentHeader()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#navbar')) {
        initTransparentHeader()
    }
})

// Countdown timer for the cart page
const initCartTimer = () => {
    const el = document.querySelector('.cart-timer')

    if (el) {
        let timer = Number(el.dataset.timerSec)
        const duration = timer
        setInterval(() => {
            let minutes = parseInt(timer / 60, 10)
            let seconds = parseInt(timer % 60, 10)

            minutes = minutes < 10 ? '0' + minutes : minutes
            seconds = seconds < 10 ? '0' + seconds : seconds

            el.querySelector('strong').textContent = minutes + ':' + seconds

            if (--timer < 0) {
                timer = duration
            }
        }, 1000)
    }
}
initCartTimer()


/*
    Lazy load videos
*/
var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
            if (video.isIntersecting) {
            for (var source in video.target.children) {
                var videoSource = video.target.children[source];
                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
                }
            }

            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
            }
        });
    });

    lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
    });
}